import React from 'react';
import { ArrowUp } from 'lucide-react';
import { CreditBadge } from './CreditBadge';

// Botón de "enviar" con los créditos DENTRO (token pill on-primary + flecha),
// forma píldora, estilo "Generar 🪙N". Se usa en los editores de imagen y video
// del historial para que el botón quede homogéneo entre ambos.
interface SendCreditsButtonProps {
  credits: number;
  onClick: () => void;
  disabled?: boolean;
  ariaLabel?: string;
}

export const SendCreditsButton: React.FC<SendCreditsButtonProps> = ({
  credits,
  onClick,
  disabled = false,
  ariaLabel = 'Enviar',
}) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    className="h-9 pl-1 pr-2.5 bg-brand-primary hover:bg-brand-primary-hover disabled:opacity-50 text-white rounded-full font-normal shadow-sm inline-flex items-center gap-1.5"
    aria-label={ariaLabel}
  >
    <CreditBadge credits={credits} size="sm" tone="on-primary" />
    <ArrowUp className="w-4 h-4" />
  </button>
);

export default SendCreditsButton;
